import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const OpenCloseIndication = (_param)=>{
    var { labels , status , hours , isExpanded , onExpand , onKeyDown  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "status",
        "hours",
        "isExpanded",
        "onExpand",
        "onKeyDown"
    ]);
     return React__default.createElement("button", swcHelpers.extends({}, rest, {
        "data-t": "OpenCloseIndication",
        className: classnames('open-close-indication', {
            'open-close-indication--expandable': Boolean(onExpand)
        }),
        tabIndex: Boolean(onExpand) ? 0 : -1,
        onClick: onExpand,
        onKeyDown: onKeyDown
    }), /*#__PURE__*/ React__default.createElement("p", {
        className: classnames('open-close-indication__indication', {
            [`open-close-indication__indication--${status.toLowerCase()}`]: true
        })
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "open-close-indication__status"
    }, labels.status), labels.indication, ' ', hours === null || hours === void 0 ? void 0 : hours.map((timePair)=>/*#__PURE__*/ React__default.createElement("span", {
            key: timePair.toString(),
            className: "open-close-indication__time-pair"
        }, timePair.length > 1 ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("time", {
            dateTime: timePair[0]
        }, timePair[0]), ` - `, /*#__PURE__*/ React__default.createElement("time", {
            dateTime: timePair[1]
        }, timePair[1])) : /*#__PURE__*/ React__default.createElement("time", {
            key: timePair[0],
            dateTime: timePair[0]
        }, timePair[0]))
    )), onExpand && /*#__PURE__*/ React__default.createElement(Icon, {
        width: 16,
        height: 16,
        className: "open-close-indication__icon",
        name: isExpanded ? 'chevron-up' : 'chevron-down'
    }));
};
var OpenCloseIndication$1 = OpenCloseIndication;

export { OpenCloseIndication$1 as default };
//# sourceMappingURL=OpenCloseIndication.js.map
